"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const teamMembers = [{
  name: "Dr. Pham Minh Tuan",
  role: "Chairman of the Board",
  degree: "PhD in Civil Engineering, Imperial College London",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_chairman.png"
}, {
  name: "Assoc. Prof. Le Thi Mai",
  role: "General Director (CEO)",
  degree: "PhD in Structural Mechanics, NUCE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_ceo.png"
}, {
  name: "Dr. Nguyen Hoang Nam",
  role: "Chief Technology Officer",
  degree: "PhD in Computer Science, KAIST",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_cto.png"
}, {
  name: "MSc. Tran Van Hung",
  role: "Head of Research",
  degree: "Master of Geotechnical Engineering, Tokyo University",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_research_head.png"
}, {
  name: "Dr. Hoang Thi Lan",
  role: "Digital Transformation Lead",
  degree: "PhD in Construction Management, Georgia Tech",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_digital_head.png"
}, {
  name: "Arch. Vu Duc Thang",
  role: "Senior Architect",
  degree: "Master of Architecture, Harvard GSD",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/team_architect.png"
}];
export default function LeadershipTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="leadership-team" ref={ref} className={cn("py-24 bg-background relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-primary mb-4 tracking-tight">
            Đội Ngũ Lãnh Đạo
          </h2>
          <p className="text-muted-foreground text-lg">
            Gặp gỡ những cá nhân tài năng steer hôm nay công ty của chúng tôi
          </p>
        </div>

        <div className="relative px-4 md:px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {teamMembers.map((member, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="h-full cursor-pointer">
                        <Card className="h-full border-border/50 bg-card/50 overflow-hidden grayscale hover:grayscale-0 transition-all duration-500 hover:shadow-lg hover:border-primary/20 group">
                          <div className="aspect-[4/5] w-full overflow-hidden relative bg-muted">
                            <img src={member.image} data-wvc-srcset={`${member.image}-wvc-srcset`} data-wvc-sizes={`${member.image}-wvc-sizes`} alt={member.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                          </div>
                          <CardHeader className="text-center pt-6 pb-2 relative z-10">
                            <CardTitle className="text-xl font-bold text-primary">
                              {member.name}
                            </CardTitle>
                            <CardDescription className="text-[color:var(--ring)] font-medium uppercase tracking-wider text-xs mt-1">
                              {member.role}
                            </CardDescription>
                          </CardHeader>
                          <CardContent className="text-center pb-6">
                            <div className="w-8 h-1 bg-primary/10 mx-auto rounded-lg group-hover:bg-[color:var(--ring)] transition-colors duration-500" />
                          </CardContent>
                        </Card>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent side="top" className="bg-primary text-primary-foreground border-none shadow-xl">
                      <p className="font-medium">{member.degree}</p>
                    </TooltipContent>
                  </Tooltip>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-4 lg:-left-12 border-primary/20 hover:bg-primary hover:text-primary-foreground" />
            <CarouselNext className="hidden md:flex -right-4 lg:-right-12 border-primary/20 hover:bg-primary hover:text-primary-foreground" />
          </Carousel>
        </div>
      </div>
    </section>;
}